module.exports = __webpack_public_path__ + "media/images/frame_footer-8b87d82bcf93b85bdf7ad8844c784da9.svg";